var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssessment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 2.33325C1.75 1.36675 2.5335 0.583252 3.5 0.583252H7.58333C7.73804 0.583252 7.88642 0.64471 7.99581 0.754106L12.0791 4.83744C12.1885 4.94684 12.25 5.09521 12.25 5.24992V11.6666C12.25 12.6331 11.4665 13.4166 10.5 13.4166H3.5C2.5335 13.4166 1.75 12.6331 1.75 11.6666V2.33325ZM3.5 1.74992C3.17783 1.74992 2.91667 2.01109 2.91667 2.33325V11.6666C2.91667 11.9888 3.17783 12.2499 3.5 12.2499H10.5C10.8222 12.2499 11.0833 11.9888 11.0833 11.6666V5.83325H7.58333C7.26117 5.83325 7 5.57208 7 5.24992V1.74992H3.5ZM8.16667 2.57488L10.2584 4.66658H8.16667V2.57488Z",
    fill: "#2B655E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.51048 8.55834C4.28268 8.78614 4.28268 9.15549 4.51048 9.38329L5.74792 10.6207C5.97573 10.8485 6.34507 10.8485 6.57288 10.6207L9.48955 7.70406C9.71735 7.47626 9.71735 7.10691 9.48955 6.87911C9.26174 6.6513 8.89239 6.6513 8.66459 6.87911L6.1604 9.38329L5.33544 8.55834C5.10764 8.33053 4.73829 8.33053 4.51048 8.55834Z",
    fill: "#2B655E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/assessment.9bba4fcd993e3eaa25af73c59fcda719.svg";
export { ForwardRef as ReactComponent };